import {
	Typography,
	Box,
	List,
	ListItem,
	Grid2,
	Paper,
	ListSubheader,
	Divider,
	Link,
} from "@mui/material";
import {
	AssessmentRounded,
	AssistantRounded,
	FiberManualRecord,
	PolicyRounded,
} from "@mui/icons-material";
import { blueGrey } from "@mui/material/colors";
import { CustomContent } from "@/components/CustomContent";
import theme from "@/styles/theme";
import { RaipOutlineLogo, WaveDecorator } from "@/assets/vectors";

const OBJECTIVES = [
	"Criar métodos de auxílio para desenvolvedores e órgãos regulamentadores para fins de avaliação de aplicações de Inteligência Artificial",
	"Ser referência para desenvolvedores e instituições no Brasil com repercussão internacional",
	"Ser uma plataforma aberta e transparente para que esta possa ser utilizada e aprimorada por toda comunidade interessada",
];

const SUBJECTS = [
	{
		Icon: PolicyRounded,
		title: "Avaliação",
		text: "Riscos éticos, violações legais e de reputação aos quais a solução de Inteligência Artificial está sujeita",
	},
	{
		Icon: AssistantRounded,
		title: "Mitigação",
		text: "Recomendações e ferramentas personalizadas para redução de riscos éticos, jurídicos e sociais",
	},
	{
		Icon: AssessmentRounded,
		title: "Relatórios",
		text: "Relatórios internos e externos produzidos através de indicadores-chave de riscos",
	},
];

export default function Home() {
	return (
		<CustomContent.Root>
			<CustomContent.Header.Container>
				<RaipOutlineLogo
					style={{ width: "100%", maxWidth: "8.75rem", minWidth: "5.625rem" }}
				/>
			</CustomContent.Header.Container>

			<CustomContent.Body>
				<Typography variant='body1'>
					Este projeto tem como principal objetivo o desenvolvimento de uma
					Plataforma Computacional, a RAIP (Responsible AI Platform), com
					metodologias e ferramentas incorporadas que auxiliem desenvolvedores e
					organizações na implementação de modelos de IA que tratam as
					principais questões de uma IA Responsável, tais como Ética,
					Sustentabilidade, Interpretabilidade, Segurança, Inclusão e
					Imparcialidade.
				</Typography>

				<List
					disablePadding
					subheader={
						<ListSubheader disableGutters>
							<Typography
								fontWeight={600}
								textTransform={"uppercase"}
								color={blueGrey[700]}
							>
								Objetivos
							</Typography>
						</ListSubheader>
					}
				>
					{OBJECTIVES.map((objective) => (
						<ListItem key={objective} disableGutters disablePadding>
							<Box display={"flex"} alignItems={"center"} gap={1.25}>
								<FiberManualRecord
									sx={{ width: 10, color: "text.secondary" }}
								/>
								<Typography color={blueGrey[700]}>{objective}</Typography>
							</Box>
						</ListItem>
					))}
				</List>

				<Divider sx={{ marginBlock: 2 }} />

				<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					<Box marginInline={"auto"} textAlign={"center"}>
						<Typography variant='h6' color={theme.palette.raip.main}>
							Temáticas
						</Typography>
						<Typography color={blueGrey[700]}>
							A plataforma é composta por três temas principais:
						</Typography>
					</Box>
					<Grid2 container spacing={4} maxWidth={1000} marginInline={"auto"}>
						{SUBJECTS.map(({ Icon, text, title }) => (
							<Grid2 key={title} size={4}>
								<Paper
									elevation={2}
									sx={{
										height: "100%",
										p: 2.5,
										pb: 4,
										textAlign: "center",
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
									}}
								>
									<Icon
										style={{
											marginInline: "auto",
											marginBottom: 6,
											width: 36,
											height: 36,
											maxWidth: 36,
											maxHeight: 36,
											color: theme.palette.raip.main,
										}}
									/>
									<Typography
										variant='subtitle1'
										color={theme.palette.raip.main}
										gutterBottom
									>
										{title}
									</Typography>
									<Typography
										variant='body2'
										sx={{ flex: 1 }}
										color={blueGrey[800]}
									>
										{text}
									</Typography>
								</Paper>
							</Grid2>
						))}
					</Grid2>
				</Box>

				<Divider sx={{ marginBlock: 2 }} />

				<Box sx={{ zIndex: 1 }}>
					<Typography variant='h6' color={theme.palette.raip.main} gutterBottom>
						Contato RAIES
					</Typography>
					<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
						<Typography>
							O Grupo RAIES (Rede de Inteligência Artificial Ética e Segura) é
							responsável pela manutenção da plataforma RAIP e também auxilia em
							orientações recomendações para os departamentos jurídicos,
							tecnológicos e éticos das instituições. Contando com especialistas
							multidisciplinares e qualificados, a equipe RAIES pode auxiliar os
							departamentos e instituições interessadas no processo de submissão
							de análise da Inteligência Artificial e interpretação dos
							resultados apresentados pela Plataforma RAIP.
						</Typography>
						<Typography>
							Incentivamos os departamentos e instituições a entrarem em contato
							com o RAIES no e-mail{" "}
							<Link
								href='mailto:raies@raies.org'
								color={theme.palette.raip.main}
							>
								raies@raies.org
							</Link>{" "}
							para quaisquer questões relacionadas à plataforma RAIP.
						</Typography>
					</Box>
				</Box>
			</CustomContent.Body>

			<WaveDecorator
				style={{
					position: "absolute",
					bottom: "-2%",
					opacity: 0.08,
					color: theme.palette.raip.main,
					width: "95%",
				}}
			/>
		</CustomContent.Root>
	);
}
